import type { Book, CommunityPost } from '../types'

export const genres = ['Literatura brasileira', 'Clássicos', 'Romance', 'Realismo', 'Naturalismo', 'Aventura', 'Fantasia', 'Ficção científica', 'História', 'Filosofia']

const ws = (rootTitle: string) => ({
  type: 'wikisource' as const,
  rootTitle,
  sourceLabel: 'Wikisource em português',
  sourceUrl: `https://pt.wikisource.org/wiki/${encodeURIComponent(rootTitle.replaceAll(' ', '_')).replaceAll('%2F', '/')}`,
  licenseLabel: 'Texto em domínio público; edição disponibilizada no Wikisource'
})

export const books: Book[] = [
  {
    id: 'dom-casmurro',
    title: 'Dom Casmurro',
    author: 'Machado de Assis',
    description: 'Bentinho tenta reconstruir a própria história e, no processo, transforma memória, ciúme e dúvida em um dos romances mais discutidos da literatura brasileira.',
    coverUrl: '/covers/dom-casmurro.svg',
    genres: ['Literatura brasileira', 'Clássicos', 'Realismo'],
    moods: ['Reflexivo', 'Irônico'],
    rating: 0,
    pages: 256,
    badge: 'Leia grátis',
    accent: '#6f56ff',
    featured: true,
    rightsStatus: 'public_domain',
    readingSource: ws('Dom Casmurro')
  },
  {
    id: 'memorias-postumas',
    title: 'Memórias Póstumas de Brás Cubas',
    author: 'Machado de Assis',
    description: 'Um narrador que já morreu decide contar sua vida com liberdade total para ironizar ambição, romance, status e a sociedade do século XIX.',
    coverUrl: '/covers/memorias-postumas.svg',
    genres: ['Literatura brasileira', 'Clássicos', 'Realismo'],
    moods: ['Irônico', 'Reflexivo'],
    rating: 0,
    pages: 240,
    badge: 'Domínio público',
    accent: '#e84d67',
    rightsStatus: 'public_domain',
    readingSource: ws('Memórias Póstumas de Brás Cubas')
  },
  {
    id: 'iracema',
    title: 'Iracema',
    author: 'José de Alencar',
    description: 'Uma lenda literária ligada ao Ceará, construída em torno do encontro entre Iracema e Martim e das tensões entre memória, origem e colonização.',
    coverUrl: '/covers/iracema.svg',
    genres: ['Literatura brasileira', 'Clássicos', 'Romance'],
    moods: ['Poético', 'Contemplativo'],
    rating: 0,
    pages: 160,
    badge: 'Ceará · grátis',
    accent: '#0f8b76',
    rightsStatus: 'public_domain',
    readingSource: ws('Iracema')
  },
  {
    id: 'o-cortico',
    title: 'O Cortiço',
    author: 'Aluísio Azevedo',
    description: 'Um retrato social intenso do Rio de Janeiro do século XIX, acompanhando ambição, exploração, desejo e sobrevivência em torno de um cortiço.',
    coverUrl: '/covers/o-cortico.svg',
    genres: ['Literatura brasileira', 'Clássicos', 'Naturalismo'],
    moods: ['Intenso', 'Social'],
    rating: 0,
    pages: 352,
    badge: 'Leia grátis',
    accent: '#d46a38',
    rightsStatus: 'public_domain',
    readingSource: ws('O Cortiço')
  },
  {
    id: 'helena',
    title: 'Helena',
    author: 'Machado de Assis',
    description: 'Após a morte de um conselheiro, uma jovem desconhecida passa a integrar a família e muda as relações, afetos e segredos dentro daquela casa.',
    coverUrl: '/covers/helena.svg',
    genres: ['Literatura brasileira', 'Clássicos', 'Romance'],
    moods: ['Dramático', 'Romântico'],
    rating: 0,
    pages: 224,
    badge: 'Domínio público',
    accent: '#b5448d',
    rightsStatus: 'public_domain',
    readingSource: ws('Helena')
  },
  {
    id: 'policarpo-quaresma',
    title: 'Triste Fim de Policarpo Quaresma',
    author: 'Lima Barreto',
    description: 'O idealismo de Policarpo Quaresma esbarra repetidamente em um país muito mais contraditório do que a imagem patriótica que ele construiu.',
    coverUrl: '/covers/policarpo-quaresma.svg',
    genres: ['Literatura brasileira', 'Clássicos'],
    moods: ['Satírico', 'Reflexivo'],
    rating: 0,
    pages: 288,
    badge: 'Leia grátis',
    accent: '#3764cc',
    rightsStatus: 'public_domain',
    readingSource: ws('Triste Fim de Policarpo Quaresma')
  },
  {
    id: 'quincas-borba',
    title: 'Quincas Borba',
    author: 'Machado de Assis',
    description: 'Rubião recebe uma herança inesperada e entra em um mundo de ambição, ingenuidade e relações em que quase tudo tem um segundo sentido.',
    coverUrl: '/covers/quincas-borba.svg',
    genres: ['Literatura brasileira', 'Clássicos', 'Realismo'],
    moods: ['Irônico', 'Psicológico'],
    rating: 0,
    pages: 304,
    badge: 'Leia grátis',
    accent: '#c4513c',
    rightsStatus: 'public_domain',
    readingSource: ws('Quincas Borba')
  },
  {
    id: 'senhora',
    title: 'Senhora',
    author: 'José de Alencar',
    description: 'Aurélia Camargo transforma casamento, dinheiro e orgulho em um jogo de poder que questiona as relações sociais do seu tempo.',
    coverUrl: '/covers/senhora.svg',
    genres: ['Literatura brasileira', 'Clássicos', 'Romance'],
    moods: ['Romântico', 'Dramático'],
    rating: 0,
    pages: 272,
    badge: 'Leia grátis',
    accent: '#8f5a31',
    rightsStatus: 'public_domain',
    readingSource: ws('Senhora')
  },
  {
    id: 'a-moreninha',
    title: 'A Moreninha',
    author: 'Joaquim Manuel de Macedo',
    description: 'Uma aposta entre estudantes leva Augusto a uma ilha e a um romance que se tornou um marco do romantismo brasileiro.',
    coverUrl: '/covers/a-moreninha.svg',
    genres: ['Literatura brasileira', 'Clássicos', 'Romance'],
    moods: ['Leve', 'Romântico'],
    rating: 0,
    pages: 208,
    badge: 'Leia grátis',
    accent: '#326b63',
    rightsStatus: 'public_domain',
    readingSource: ws('A Moreninha (1860)')
  },
  {
    id: 'tide-city',
    title: 'A Cidade entre Marés',
    author: 'LIVROOM Studio',
    description: 'Uma novela curta original sobre memória, pertencimento e uma cidade costeira que muda de mapa a cada grande maré.',
    coverUrl: '/covers/tide-city.svg',
    genres: ['Fantasia', 'Literatura brasileira'],
    moods: ['Atmosférico', 'Reflexivo'],
    rating: 0,
    pages: 84,
    badge: 'LIVROOM Original',
    accent: '#173a46',
    rightsStatus: 'licensed'
  },
  {
    id: '1984',
    title: '1984',
    author: 'George Orwell',
    description: 'Uma sociedade vigiada por um Estado absoluto e um homem que tenta preservar a própria liberdade de pensamento.',
    coverUrl: '/covers/1984.svg',
    genres: ['Clássicos', 'Ficção científica'],
    moods: ['Tenso', 'Reflexivo'],
    rating: 0,
    pages: 328,
    badge: 'Conheça a obra',
    accent: '#8f5cff',
    rightsStatus: 'metadata_only'
  },
  {
    id: 'pride',
    title: 'Orgulho e Preconceito',
    author: 'Jane Austen',
    description: 'Um clássico sobre relações, orgulho, primeiras impressões e escolhas afetivas.',
    coverUrl: '/covers/pride.svg',
    genres: ['Romance', 'Clássicos'],
    moods: ['Romântico', 'Irônico'],
    rating: 0,
    pages: 432,
    badge: 'Conheça a obra',
    accent: '#f377c8',
    rightsStatus: 'metadata_only'
  },
  {
    id: 'hobbit',
    title: 'O Hobbit',
    author: 'J. R. R. Tolkien',
    description: 'Uma aventura fantástica sobre coragem, amizade e uma jornada que muda tudo.',
    coverUrl: '/covers/hobbit.svg',
    genres: ['Fantasia', 'Clássicos'],
    moods: ['Aventureiro', 'Aconchegante'],
    rating: 0,
    pages: 320,
    badge: 'Conheça a obra',
    accent: '#5bd2d2',
    rightsStatus: 'metadata_only'
  },
  {
    id: 'dune',
    title: 'Duna',
    author: 'Frank Herbert',
    description: 'Política, religião, ecologia e poder em uma das obras mais influentes da ficção científica.',
    coverUrl: '/covers/dune.svg',
    genres: ['Ficção científica'],
    moods: ['Épico', 'Complexo'],
    rating: 0,
    pages: 688,
    badge: 'Conheça a obra',
    accent: '#f9a43f',
    rightsStatus: 'metadata_only'
  }
]

export const communityPosts: CommunityPost[] = [
  {
    id: 'p1', user: 'Lia Martins', handle: '@liamartins', avatar: 'LM', time: '8 min',
    text: 'Estou relendo Dom Casmurro e a discussão sobre narrador não confiável muda completamente a forma de ler certos capítulos.',
    book: 'Dom Casmurro', likes: 0, comments: 0, tag: 'Sem spoilers'
  },
  {
    id: 'p2', user: 'Rafael Nunes', handle: '@rafalendo', avatar: 'RN', time: '21 min',
    text: 'Descobri Iracema aqui e gostei de poder abrir o texto sem sair caçando PDF aleatório na internet.',
    book: 'Iracema', likes: 0, comments: 0, tag: 'Leitura livre'
  },
  {
    id: 'p3', user: 'Maya Costa', handle: '@mayac', avatar: 'MC', time: '43 min',
    text: 'Qual clássico brasileiro vocês acham mais fácil para quem está voltando a ler agora?',
    likes: 0, comments: 0, tag: 'Pergunta'
  }
]
